import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
/* actions */
import { getAllIVRs, editIVRsAudio } from '../../redux/actions/ivrs';
import ErrorMsgField from '../../components/ErrorMsgField';
/* components */
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/ivrChangeAudio';
import config from '../../api/config.json';

function Edit (props) {
  const { id } = props.match.params;
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema
  });
  const ivrs = useSelector(state => state.ivrs);
  const ivr = ivrs.data.find(ivr => ivr._id === id);
  const dispatch = useDispatch();
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    audio: {}
  };
  const [data, setData] = useState(INITIAL_VALUES);
  const submitButton = useRef();
  const audioField = useRef();

  useEffect(() => {
    dispatch(getAllIVRs());
  }, [dispatch]);

  useEffect(() => {
    if (ivr) {
      const newData = {
        ...ivr,
        deviceId: ivr.deviceId ? ivr.deviceId._id : null,
        department: ivr.department._id,
        audio: {}
      };
      setData(newData);
    }
  }, [ivr]);

  const submit = () => {
    dispatch(editIVRsAudio(data, submitButton.current));
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  const handleChangeAudio = evt => {
    const { value, files, name } = evt.target;
    const tagAudio = audioField.current;
    const extesion = value.slice(-4).toLowerCase();
    if (extesion === '.wav' && files && files[0]) {
      const reader = new FileReader();
      reader.onload = e => {
        tagAudio.setAttribute('src', e.target.result);
      };
      reader.readAsDataURL(files[0]);
      setData({ ...data, [name]: files[0] });
    } else {
      tagAudio.setAttribute('src', '');
      setData({ ...data, [name]: {} });
    }
  };

  return (
    <div className="container-fluid">
      {ivrs.editSuccess && (
        <AlertMsg type="success" msg="Áudio atualizado com sucesso" />
      )}
      {ivrs.editError && (
        <AlertMsg type="danger" msg="Falha durante atualização do áudio" />
      )}
      {!ivrs.editSuccess && !ivrs.editError && (
        <AlertMsg type="info" msg="Área atualização áudio da URA" />
      )}
      <FormHeader title="Atualizar Áudio" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">
                Nome<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                onChange={handleChange}
                defaultValue={data.name}
                disabled={true}
                ref={register}
              />
              {errors.name && errors.name.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="currentAudio">Áudio Atual</label>
              <audio
                id="currentAudio"
                name="currentAudio"
                src={`${config.protocol}://${config.ipServerGW}:${
                  config.portServerGW
                }/api/ivrs/audio?file=${id}.wav&token=${localStorage.getItem(
                  'token'
                )}`}
                className="audio-preview"
                controls
              ></audio>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="audio">
                Áudio&nbsp;
                <span className="badge badge-info align-text-top">
                  Codec Suportado WAV
                </span>
                <span className="field-required">*</span>
              </label>
              <input
                type="file"
                className="form-control-file"
                id="audio"
                name="audio"
                autoComplete="off"
                accept="audio/wav"
                onChange={handleChangeAudio}
                ref={register}
              />
              {errors.audio && errors.audio.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.audio && errors.audio.type === 'fileFormat' && (
                <ErrorMsgField type="fileFormat" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="listen">Novo Áudio</label>
              <audio
                id="listen"
                name="listen"
                className="audio-preview"
                controls
                controlsList="nodownload"
                ref={audioField}
              ></audio>
            </div>
          </div>
        </div>
        <FormFooter url="/ivrs" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
